import React from 'react'
import { ConfirmDialog } from 'lib.front'

export const AlertDialog = ({openConfirmD,setOpenConfirmD, titulo, onConfirm, onCancel}) => {
    return (
        <ConfirmDialog
            open={openConfirmD}
            setOpen={setOpenConfirmD}
            titulo={titulo}
            onConfirm={onConfirm}
            variant={'warning'}
            onCancel={onCancel}
        />
    )
}
